/**
 * Normalization between Connection API club group types and Club Settings / Finance UI.
 */

/** Legacy Sportadmin-style label; behavior is still `instructors` / instruktörsgrupp. */
export function normalizeClubGroupTypeDisplayName(name) {
  const n = typeof name === "string" ? name.trim() : "";
  if (n === "Föreningsorganisation") return "Instruktörer";
  return n;
}

/**
 * @param {unknown} row
 */
export function normalizeClubGroupTypeFromApi(row) {
  if (!row || typeof row !== "object") return null;
  const rawName = typeof row.name === "string" ? row.name : "";
  return {
    id: String(row.id),
    name: normalizeClubGroupTypeDisplayName(rawName),
    description: typeof row.description === "string" ? row.description : "",
    sortOrder:
      typeof row.sortOrder === "number"
        ? row.sortOrder
        : typeof row.sort_order === "number"
          ? row.sort_order
          : 100,
    isActive: row.isActive !== false && row.is_active !== false,
    groupCount: Number(row.groupCount ?? row.group_count ?? 0) || 0,
    filterLegacyKey: String(row.filterLegacyKey ?? row.filter_legacy_key ?? "other"),
    defaultKidsGroup: Boolean(row.defaultKidsGroup ?? row.default_kids_group),
    defaultColorPromotion: Boolean(row.defaultColorPromotion ?? row.default_color_promotion),
    defaultUngdom: Boolean(row.defaultUngdom ?? row.default_ungdom),
    defaultVuxen: Boolean(row.defaultVuxen ?? row.default_vuxen),
    defaultInstructorsGroup: Boolean(row.defaultInstructorsGroup ?? row.default_instructors_group),
  };
}

/**
 * @param {{
 *   name: string;
 *   description?: string;
 *   sortOrder?: number;
 *   isActive?: boolean;
 *   filterLegacyKey?: string;
 *   defaultKidsGroup?: boolean;
 *   defaultColorPromotion?: boolean;
 *   defaultUngdom?: boolean;
 *   defaultVuxen?: boolean;
 *   defaultInstructorsGroup?: boolean;
 * }} form
 */
export function clubGroupTypeFormToApiPayload(form) {
  const sortOrder = Number(form.sortOrder) || 100;
  return {
    name: form.name.trim(),
    description: (form.description || "").trim(),
    sortOrder,
    sort_order: sortOrder,
    isActive: Boolean(form.isActive),
    is_active: Boolean(form.isActive),
    filterLegacyKey: form.filterLegacyKey || "other",
    filter_legacy_key: form.filterLegacyKey || "other",
    defaultKidsGroup: Boolean(form.defaultKidsGroup),
    default_kids_group: Boolean(form.defaultKidsGroup),
    defaultColorPromotion: Boolean(form.defaultColorPromotion),
    default_color_promotion: Boolean(form.defaultColorPromotion),
    defaultUngdom: Boolean(form.defaultUngdom),
    default_ungdom: Boolean(form.defaultUngdom),
    defaultVuxen: Boolean(form.defaultVuxen),
    default_vuxen: Boolean(form.defaultVuxen),
    defaultInstructorsGroup: Boolean(form.defaultInstructorsGroup),
    default_instructors_group: Boolean(form.defaultInstructorsGroup),
  };
}
